import React from "react";
import Contact from "../contactus/Contact";
import Home from "../home/Home";
import About from "../about/About";
import Services from "../services/Services";

function MainHome() {
  return (
    <>
      <Home />
      <About />
      <Services />
      <Contact />
    </>
  );
}

export default MainHome;
